import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BottomNav from '../components/BottomNav';

const Reservation = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const vehicle = searchParams.get('vehicle') || 'Unknown Vehicle';

  const [formData, setFormData] = useState({
    date: '',
    time: '',
    people: 1,
    duration: 1,
    address: ''
  });

  const hourlyRate = 300;
  const totalCost = hourlyRate * formData.duration;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Store reservation details and navigate to confirmation
    localStorage.setItem('reservationDetails', JSON.stringify({
      vehicle,
      ...formData,
      totalCost
    }));
    alert('Reservation confirmed! Thank you.');
    navigate('/dashboard');
  };

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Reserve Vehicle</h1>
        <div className="underline"></div>

        <div className="card">
          <div className="badge badge-gold mb-md">{vehicle.toUpperCase()}</div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Date:</label>
              <input
                type="date"
                name="date"
                className="form-input"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Time:</label>
              <input
                type="time"
                name="time"
                className="form-input"
                value={formData.time}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Number of People:</label>
              <input
                type="number"
                name="people"
                className="form-input"
                min="1"
                max="7"
                value={formData.people}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Duration (Hours):</label>
              <input
                type="number"
                name="duration"
                className="form-input"
                min="1"
                max="12"
                value={formData.duration}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Address:</label>
              <input
                type="text"
                name="address"
                className="form-input"
                placeholder="Enter your address"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>

            <div className="alert alert-info">
              <strong>Total Cost: R{totalCost}.00</strong>
            </div>

            <button type="submit" className="btn btn-primary">
              Reserve Now
            </button>
          </form>
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default Reservation;
